(function () {
  'use strict';

  angular
    .module('duo-routes.cadastro-rotas', [
      'ui.router',
      'ui.bootstrap',
      'blockUI',
      'restangular',
      'httpServiceV3gModule',
      'ConstantVfiltroModule',
      'ServiceVfiltroModule',
      'FactoryVfiltroModule',
      'ObjetosVfiltroModule',
      'safetyModule',
      'ngSanitize'
    ]);
}());
